export const contextTypes = {
  LOCWP: "LOCWP",
  GC: "GC",
  UNKNOWN: "UNKNOWN"
};

export const attachmentTypes = [
  "Photo",
  "Tentative Agreement",
  "Inspection Release Tag",
  "Mini Memo",
  "Other"
];
